import { FormLabel } from "../form/Form";

const FormRequiredLabel = ({ text }) => {
  return (
    <FormLabel>
      {text} <strong className="text-red-500">*</strong>
    </FormLabel>
  );
};

export default FormRequiredLabel;